import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

interface FeatureProps {
  bgColor: string;
}

export const WorkHereContainerRow = styled(Row)<FeatureProps>`
  background: ${({ bgColor }) => `${bgColor}`};
  width: 100%;
  padding-bottom: ${({ theme }) => theme.x4spacePx}px;
`;

export const WorkHereContent = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px;
  ${media.lgUp`
    max-width: 700px;
    margin: ${({ theme }) => theme.x7spacePx}px auto ${({ theme }) =>
      theme.x4spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
    margin-bottom: ${({ theme }) => theme.x4spacePx}px;
  }
  a {
    ${({ theme }) => theme.typography.xSmall};
    background-color: ${({ theme }) => theme.color.brand01};
    border-radius: 5px;
    color: #fff;
    padding: ${({ theme }) => theme.x2spacePx}px;
    text-decoration: none;
  }
`;
